// extracted by mini-css-extract-plugin
export default {"container":"FileInput_container__TEEZP","dragOver":"FileInput_dragOver__of2ZA","icon":"FileInput_icon__QlkXa"};